// Text — presentation primitive.
// Props:
//   as:      'p'|'span'|'div'                                 (default 'p')
//   size:    'xs'|'sm'|'md'|'lg'|'xl'                          (default 'md')
//   tone:    'primary'|'secondary'|'tertiary'|'danger'|'success' (default 'primary')
//   weight:  'regular'|'medium'|'semibold'|'bold'              (default 'regular')
//   leading: 'tight'|'normal'|'relaxed'                        (default 'normal')
//   className, id, children, ...rest

function Text({
  as = 'p',
  size = 'md',
  tone = 'primary',
  weight = 'regular',
  leading = 'normal',
  className = '',
  children,
  ...rest
}) {
  const Tag = as;
  const classes = [
    'ui-text',
    `ui-text--${size}`,
    `ui-text--tone-${tone}`,
    `ui-text--weight-${weight}`,
    `ui-text--leading-${leading}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

export default Text;
